import * as React from 'react';
import { DialogTitle } from 'components/Dialog';
import { ContentContainer } from 'pages/Onboarding/StepTwo/ContentStyle';
import {
  BukalapakDialogContent,
  BukalapakDialogTitle
} from 'pages/Onboarding/StepTwo/MarketPlacesDialog/Bukalapakk/DialogContent';
import PrimaryDialog from 'pages/Onboarding/StepTwo/PrimaryDialog';
import BukalapakFullIcon from 'assets/img/bukalapak-full.png';
import LazadaFullIcon from 'assets/img/lazada-full.png';
import ShopeeFullIcon from 'assets/img/shopee-full.png';
import TokopediaFullIcon from 'assets/img/tokopedia-full.png';
import BlibliFullIcon from 'assets/img/blibli-full.png';
import ZaloraFullIcon from 'assets/img/zalora.png';
import AkulakuFullIcon from 'assets/img/akulaku-full.png';
import BukalapakContent from 'pages/Onboarding/StepTwo/MarketPlacesDialog/Bukalapak/DialogContent';
import LazadaContent from 'pages/Onboarding/StepTwo/MarketPlacesDialog/Lazada/DialogContent';
import ShopeeContent from 'pages/Onboarding/StepTwo/MarketPlacesDialog/Shopee/DialogContent';
import TokopediaContent from 'pages/Onboarding/StepTwo/MarketPlacesDialog/Tokopedia/DialogContent';
import { getChannelList } from 'api/integrationStep';
import { showAlert } from 'components/Alert';
import BlibliContent from 'pages/Onboarding/StepTwo/MarketPlacesDialog/Blibli/DialogContent';
import ZaloraContent from 'pages/Onboarding/StepTwo/MarketPlacesDialog/Zalora/DialogContent';
import AkulakuContent from 'pages/Onboarding/StepTwo/MarketPlacesDialog/Akulaku/DialogContent';
import TadaFullIcon from 'assets/img/tada-full.png';
import TADAContent from 'pages/Onboarding/StepTwo/MarketPlacesDialog/TADA/DialogContent';
import EvermosFullIcon from 'assets/img/evermos-full.png';
import EvermosContent from 'pages/Onboarding/StepTwo/SocialCommerceDialog/Evermos/DialogContent';
import FacebookFullIcon from 'assets/img/new-facebook.svg';
import FacebookContent from 'pages/Onboarding/StepTwo/SocialCommerceDialog/Facebook/DialogContent';
import TiktokFullIcon from 'assets/img/tokopedia_shop.png';
import TiktokContent from 'pages/Onboarding/StepTwo/SocialCommerceDialog/Tiktok/DialogContent';
import WoocommerceFullIcon from 'assets/img/woocommerce-full.png';
import WooCommerceContent from 'pages/Onboarding/StepTwo/WebstoreDialog/WooCommerce/DialogContent';
import ShopifyFullIcon from 'assets/img/shopify-full.png';
import ShopifyContent from 'pages/Onboarding/StepTwo/WebstoreDialog/Shopify/DialogContent';
import ShoplineContent from 'pages/Onboarding/StepTwo/WebstoreDialog/Shopline/DialogContent';
import ShoplineIcon from 'assets/img/shopline.png';
import PlugoContent from 'pages/Onboarding/StepTwo/WebstoreDialog/Plugo/DialgContent';
import PlugoFullIcon from 'assets/img/plugo-full.png';

const ModalIntegration = (props): React.ReactElement => {
  const { open, onClose, isConnected, chData } = props;
  const [channels, setChannelList] = React.useState<{ channel_id: number; store_id: number; store_name: string }[]>([]);
  let title: React.ReactElement | undefined = null;
  let content: React.ReactElement | undefined = null;

  const getListChannel = async () => {
    try {
      const { data, status, statusText } = await getChannelList();
      if (status === 200) {
        setChannelList(data);
      } else {
        showAlert('error', `Something went wrong ${statusText}`, 5000);
      }
    } catch (err) {
      const error = err as Error;
      console.error(error);
    }
  }

  switch (chData?.channel_id) {
    case 2:
      title = <DialogTitle logoSize={{ width: '122px', height: '37px' }} image={BukalapakFullIcon} altName="shopee" />;
      // eslint-disable-next-line react/jsx-no-undef
      content = <BukalapakContent />;
      break;
    case 4:
      title = <DialogTitle logoSize={{ width: '112px', height: '26px' }} image={LazadaFullIcon} altName="lazada" />;
      // eslint-disable-next-line react/jsx-no-undef
      content = <LazadaContent chData={chData} isConnected={isConnected} />;
      break;
    case 64:
      title = <DialogTitle logoSize={{ width: '112px', height: '26px' }} image={ShopeeFullIcon} altName="shopee" />;
      // eslint-disable-next-line react/jsx-no-undef
      content = <ShopeeContent chData={chData} isConnected={isConnected} />;
      break;
    case 128:
      title = <DialogTitle logoSize={{ width: '112px', height: '26px' }} image={TokopediaFullIcon} altName="tokopedia" />;
      // eslint-disable-next-line react/jsx-no-undef
      content = <TokopediaContent chData={chData} isConnected={isConnected} handleClosePrimary={onClose} getListChannel={getListChannel} />;
      break;
    case 32:
      title = <DialogTitle logoSize={{ width: '112px', height: '26px' }} image={BlibliFullIcon} altName="blibli" />;
      // eslint-disable-next-line react/jsx-no-undef
      content = <BlibliContent chData={chData} isConnected={isConnected} handleClosePrimary={onClose} getListChannel={getListChannel} />;
      break;
    case 8:
      title = <DialogTitle logoSize={{ width: '112px', height: '26px' }} image={ZaloraFullIcon} altName="zalora" />;
      // eslint-disable-next-line react/jsx-no-undef
      content = <ZaloraContent handleClosePrimary={onClose} getListChannel={getListChannel} />;
      break;
    case 65536:
      title = <DialogTitle logoSize={{ width: '112px', height: '26px' }} image={AkulakuFullIcon} altName="zalora" />;
      // eslint-disable-next-line react/jsx-no-undef
      content = <AkulakuContent chData={chData} isConnected={isConnected} />;
      break;
    case 131077:
      title = <DialogTitle logoSize={{ width: '66px', height: '21px' }} image={TadaFullIcon} altName="tada" />;
      // eslint-disable-next-line react/jsx-no-undef
      content = <TADAContent handleClosePrimary={onClose} getListChannel={getListChannel} />;
      break;
    case 131078:
      title = <DialogTitle logoSize={{ width: '45px', height: '22px' }} image={EvermosFullIcon} altName="evermos" />;
      // eslint-disable-next-line react/jsx-no-undef
      content = <EvermosContent handleClosePrimary={onClose} getListChannel={getListChannel} />;
      break;
    case 16386:
      title = <DialogTitle logoSize={{ width: '92px', height: '17px' }} image={FacebookFullIcon} altName="facebook" />;
      // eslint-disable-next-line react/jsx-no-undef
      content = <FacebookContent chData={chData} isConnected={isConnected} />;
      break;
    case 131076:
      title = <DialogTitle logoSize={{ width: '200px', height: 'auto' }} image={TiktokFullIcon} altName="tiktok" />;
      // eslint-disable-next-line react/jsx-no-undef
      content = <TiktokContent chData={chData} isConnected={isConnected} />;
      break;
    case 131072:
      title = <DialogTitle logoSize={{ width: '125px', height: '34px' }} image={WoocommerceFullIcon} altName="woocommerce" />;
      // eslint-disable-next-line react/jsx-no-undef
      content = <WooCommerceContent handleClosePrimary={onClose} getListChannel={getListChannel} />;
      break;
    case 1048576:
      title = <DialogTitle logoSize={{ width: '107px', height: '32px' }} image={ShopifyFullIcon} altName="shopify" />;
      // eslint-disable-next-line react/jsx-no-undef
      content = <ShopifyContent handleClosePrimary={onClose} getListChannel={getListChannel} />;
      break;
    case 131079:
      title = <DialogTitle logoSize={{ width: '108px', height: '34px' }} image={ShoplineIcon} altName="shopline" />;
      // eslint-disable-next-line react/jsx-no-undef
      content = <ShoplineContent chData={chData} isConnected={isConnected} />;
      break;
    case 131084:
      title = <DialogTitle logoSize={{ width: '108px', height: '34px' }} image={PlugoFullIcon} altName="plugo" />;
      // eslint-disable-next-line react/jsx-no-undef
      content = <PlugoContent chData={chData} isConnected={isConnected} handleClosePrimary={onClose} getListChannel={getListChannel} />;
      break;
    default:
      break;
  }
  // console.info('props => ', props);
  return (
    <ContentContainer>
      <PrimaryDialog title={title} content={content} open={open} handleClose={onClose} />
    </ContentContainer>
  );
};

export default ModalIntegration;
